export class instituciones{

	public idInstitucionPk: number;
	public dsc: string;
	public idProcesadorFk: number;
	public idBm: string;
	public flgCamara: boolean = false;
	public flgAgregadorTecnologico: boolean= false;
	public flgAdquirente: boolean= false;
	public flgEmisor: boolean= false;
	public flgAutPorAgregador: boolean= false;
	public flgSoporteCash: boolean=false;
	public flgCashCredito: boolean=false;
	public idAgregador: number;
	public idBo: number;
	public idAnt: number;
	public id: number;
	public idBco: string;
	public procesador: string;
	public tipoInst: string;
	public flgActiva: boolean=false;
	public cardFiCred: string;
	public cardFiDeb: string;
	public prefBin: string;
	public razonSocial: string;
	public entidad_id: number;
	public entidadID: string;
	public multired: boolean;
	public idBancoAtm: string;
	public flgActivaBm: number;
}